import PropTypes from 'prop-types';

export const moneyAmount = PropTypes.shape({
  value: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired
});
